import React from "react";
import { connect } from "react-redux";
import SingleSelect from "components/Select/SingleSelect";
import { Grid } from "@material-ui/core";
import { setDataTypeCommon } from "actions";

const OPTIONS = [
  { name: "チェックイン", value: "checkin" },
  { name: "報告", value: "report" },
];

const DataTypeSelectorCommon = ({ dataType, setDataTypeCommon }) => {
  const handleChange = (event) => {
    setDataTypeCommon(event.target.value);
  };

  return (
    <Grid
      container
      spacing={1}
      direction="row"
      style={{ width: "auto", flex: "0 0 auto" }}
    >
      <Grid item spacing={1} style={{ marginTop: 8 }}>
        データタイプ：
      </Grid>
      <Grid item style={{ marginTop: -8 }}>
        <SingleSelect
          selected={{ value: dataType || "checkin" }}
          options={OPTIONS}
          handleChange={handleChange}
        />
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state) => ({
  dataType: state.pictreeCommon.dataType,
});

const mapDispatchToProps = (dispatch) => ({
  setDataTypeCommon: (param) => dispatch(setDataTypeCommon(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DataTypeSelectorCommon);
